module.exports = function getResource(label) {
    const resources = {
        seeItInRealLife: 'See It in Real Life',
        addYourPhoto: '+ Add your photo',
        addAPhoto: 'Add a photo',
        sorryNoImages: 'Sorry, no images match the applied filters.'
    };
    return resources[label];
};
